export default __webpack_public_path__ + "static/media/noimage.2193ff58.png";